import { EditIcon } from '@assets/icons';
import { Group } from '@components/layout';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import type { Editor } from '@generated/graphql';
import { MenuItem } from '@mui/material';
import type { MouseEventHandler } from 'react';
import { EditServerModal } from '../modals/EditServerModal';

type EditServerOptionProps = {
  server: Pick<
    Editor,
    | 'editorId'
    | 'name'
    | 'instanceType'
    | 'status'
    | 'autoStopEnabled'
    | 'autoStopCpuThreshold'
    | 'autoStopTimeoutMinutes'
    | 'autoDeleteEnabled'
    | 'autoDeleteTimeoutDays'
    | 'autoUpdateEnabled'
    | 'visibility'
  >;
  onClick: MouseEventHandler;
  onEdit: () => void;
};

export const EditServerOption = ({ server, onClick, onEdit }: EditServerOptionProps) => {
  const { showModal: showEditServerModal } = useModal({
    component: EditServerModal,
    componentProps: {
      server,
      onEdit,
    },
    modalProps: { title: 'Edit server' },
  });

  const handleEditClick: MouseEventHandler = (event) => {
    onClick(event);
    showEditServerModal();
  };

  return (
    <MenuItem onClick={handleEditClick}>
      <Group alignItems="center" gap={2}>
        <EditIcon size={14} />
        <Typography variant="caption2">Edit</Typography>
      </Group>
    </MenuItem>
  );
};
